/**
 * The presence property class that contains presence properties, including the publisher's user ID and current presence state, and the platform used by the online device, as well as the presence's extension information, update time, and subscription expiration time.
 */
export class ChatPresence {
  /**
   * The user ID of the presence publisher.
   */
  publisher: string;
  /**
   * The presence description information.
   */
  statusDescription: string;
  /**
   * The presence update time, which is generated by the server.
   */
  lastTime: string;
  /**
   * The expiration time of the presence subscription.
   */
  expireTime: string;
  /**
   * The details of the current presence state.
   */
  statusDetails: Map<string, number>;

  constructor(params: {
    publisher: string;
    statusDescription: string;
    lastTime: string;
    expireTime: string;
    statusDetails: Map<string, number>;
  }) {
    this.publisher = params.publisher;
    this.statusDescription = params.statusDescription;
    this.lastTime = params.lastTime;
    this.expireTime = params.expireTime;
    this.statusDetails = params.statusDetails;
  }
}
